import script from "./NavBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./NavBar.vue?vue&type=script&setup=true&lang=ts"

import "./NavBar.vue?vue&type=style&index=0&id=45aef821&lang=scss&scoped=true"

import exportComponent from "/var/www/digital-card-solution-limited/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45aef821"]])

export default __exports__